import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const MobileSearchWrapper = styled.div<{ $active: boolean }>(
  p => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    ${p.$active &&
      css`
        position: fixed;
        padding-right: ${layout.measurements.spacing050};
        padding-left: ${layout.measurements.spacing050};
        top: 0;
        left: 0;
        right: 0;
        height: 56px;
        z-index: 9999;
        background: ${p.theme.bg.primary};
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 9999;
      `};
  `
);

export const CloseButton = styled(Clickable)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.text.primary};
`;
